import { useState } from "react";
import methodModel from "../../../methods/methods";
import SelectDropdown from "../SelectDropdown";
import "./style.scss";
import ReactQuill from "react-quill";
import PhoneInput from "react-phone-input-2";
import MultiSelectDropdown from "../MultiSelectDropdown";
import datepipeModel from "../../../models/datepipemodel";
export default function FormControl({
  name = "",
  id = "",
  valueType = "string",
  onInputChange = (e: any) => {},
  inputValue = "",
  displayValue = "name",
  placeholder = "",
  type = "text",
  options = [],
  error,
  label,
  required = false,
  onChange = () => {},
  maxlength = "",
  minlength = "",
  min = "",
  max = "",
  className = "",
  value,
  disabled = false,
  theme = "",
  onkeyDown = (e: any) => {},
}: any) {
  const [text, setText] = useState("");

  const add = () => {
    let arr = value || [];
    if (text) {
      arr.push(text);
    }
    onChange(arr);
    setText("");
  };

  const remove = (i: any) => {
    let arr = value || [];
    arr = arr.filter((itm: any, index: any) => index != i);
    onChange(arr);
  };

  const addItem = (v: any) => {
    let arr = value || [];
    let ext = arr?.find((itm: any) => itm == v);

    if (ext) {
      arr = arr.filter((itm: any) => itm != v);
    } else {
      arr.push(v);
    }

    onChange(arr);
  };

  const twHours: any = [
    { id: "00:00", name: "00:00" },
    { id: "01:00", name: "01:00" },
    { id: "02:00", name: "02:00" },
    { id: "03:00", name: "03:00" },
    { id: "04:00", name: "04:00" },
    { id: "05:00", name: "05:00" },
    { id: "06:00", name: "06:00" },
    { id: "07:00", name: "07:00" },
    { id: "08:00", name: "08:00" },
    { id: "09:00", name: "09:00" },
    { id: "10:00", name: "10:00" },
    { id: "11:00", name: "11:00" },
    { id: "12:00", name: "12:00" },
    { id: "13:00", name: "13:00" },
    { id: "14:00", name: "14:00" },
    { id: "15:00", name: "15:00" },
    { id: "16:00", name: "16:00" },
    { id: "17:00", name: "17:00" },
    { id: "18:00", name: "18:00" },
    { id: "19:00", name: "19:00" },
    { id: "20:00", name: "20:00" },
    { id: "21:00", name: "21:00" },
    { id: "22:00", name: "22:00" },
    { id: "23:00", name: "23:00" },
  ];
  const filteredHours = twHours.filter((hour: any) => {
    return (!min || hour.id >= min) && (!max || hour.id <= max);
  });

  return (
    <>
      <div className="formWrapper  relative">
        {label ? (
          <>
            <label className="text-[#092C4C] pb-[6px] font-[500] block">
              {label}{" "}
              {required ? (
                <>
                  <span className="star">*</span>
                </>
              ) : (
                <></>
              )}
            </label>
          </>
        ) : (
          <></>
        )}

        {type == "select" ? (
          <SelectDropdown
            id={`statusDropdown_${id}`}
            displayValue={displayValue}
            className={className}
            valueType={valueType}
            onInputChange={onInputChange}
            inputValue={inputValue}
            placeholder={placeholder}
            intialValue={value || ""}
            name={name}
            theme={theme}
            result={(e: any) => {
              onChange(e.value);
            }}
            options={options}
            required={required}
            disabled={disabled}
          />
        ) : type == "time" ? (
          <SelectDropdown
            id={`timeDropdown_${id}`}
            displayValue="name"
            className={className}
            valueType="string"
            onInputChange={onInputChange}
            inputValue={value || ""}
            placeholder={placeholder || "Select Time"}
            intialValue={value || ""}
            name={name}
            min={min}
            max={max}
            theme={theme}
            result={(e: any) => {
              onChange(e.value);
            }}
            options={filteredHours} // Use filtered hours here
            required={required}
            disabled={disabled}
          />
        ) : type == "timee" ? (
          <SelectDropdown
            id={`timeDropdown_${id}`}
            displayValue="name"
            className={className}
            valueType="string"
            onInputChange={onInputChange}
            inputValue={value || ""}
            placeholder={placeholder || "Select Time"}
            intialValue={value || ""}
            name={name}
            theme={theme}
            result={(e: any) => {
              onChange(e.value);
            }}
            options={twHours} // Use filtered hours here
            required={required}
            disabled={disabled}
          />
        ) : type == "multiselect" ? (
          <MultiSelectDropdown
            id={`statusDropdown_${id}`}
            displayValue={displayValue}
            className={className}
            placeholder={placeholder}
            intialValue={value || ""}
            result={(e: any) => {
              onChange(e.value);
            }}
            required={required}
            options={options}
            disabled={disabled}
          />
        ) : type == "phone" ? (
          <>
            <PhoneInput
              country={"jp"}
              onlyCountries={["jp"]}
              value={value}
              // placeholder="+44 0000000000"
              enableSearch={false}
              onChange={(e) => onChange(e)}
              countryCodeEditable={true}
              disableDropdown={true}
              inputClass={className}
              inputProps={{
                name: name,
              }}
            />
          </>
        ) : type == "number" ? (
          <input
            type="text"
            name={name}
            className={`relative  bg-white w-full rounded-lg h-11 flex items-center gap-2 overflow-hidden border border-[#00000036] px-3 form-control ${className}`}
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={maxlength}
            minLength={minlength}
            min={min}
            disabled={disabled}
            autoComplete="off"
            onChange={(e) => onChange(methodModel.isNumber(e))}
          />
        ) : type == "badge" ? (
          <>
            <div className="flex">
              <input
                type="text"
                className={`relative border border-[#00000036] bg-white w-full rounded-lg h-11 flex items-center gap-2 overflow-hidden px-3 form-control ${className}`}
                placeholder={placeholder}
                value={text}
                disabled={disabled}
                autoComplete="off"
                onChange={(e) => setText(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-primary ml-2"
                disabled={disabled}
                onClick={add}
              >
                Add
              </button>
            </div>
            <div className="">
              {value?.map((itm: any, i: any) => {
                return (
                  <span className="badge badge-primary m-1">
                    {itm}
                    <i
                      className="fa fa-times ml-1"
                      onClick={() => remove(i)}
                    ></i>
                  </span>
                );
              })}
            </div>
          </>
        ) : type == "radio" ? (
          <>
            <div className="flex items-center gap-x-4 mt-3">
              {options.map((itm: any) => {
                return (
                  <div className="">
                    {" "}
                    <label className="border border-[#00000036] px-6 py-2 rounded-lg flex cursor-pointer">
                      <input
                        type="radio"
                        checked={value == itm.id ? true : false}
                        onChange={(e) => onChange(itm.id)}
                        className="mr-2"
                        name={name}
                        autoComplete="off"
                        disabled={disabled}
                      />
                      {itm.name}
                    </label>
                  </div>
                );
              })}
            </div>
          </>
        ) : type == "textarea" ? (
          <>
            <textarea
              name={name}
              className={`relative border border-[#00000036] bg-white w-full rounded-lg h-[150px] flex items-center gap-2 overflow-hidden px-3 pt-2 form-control ${className}`}
              required={required}
              placeholder={placeholder}
              value={value || ""}
              maxLength={maxlength}
              minLength={minlength}
              disabled={disabled}
              autoComplete="off"
              onChange={(e) => {
                onChange(e.target.value);
              }}
              onKeyDown={onkeyDown}
            />
          </>
        ) : type == "editor" ? (
          <>
            <ReactQuill
              theme="snow"
              value={value}
              onChange={onChange}
              className={`form-control ${className}`}
            />
          </>
        ) : type == "checkbox" ? (
          <>
            {options.map((itm: any) => {
              return (
                <label className="flex">
                  <input
                    type="checkbox"
                    checked={value?.includes(itm.id) ? true : false}
                    onChange={(e) => addItem(itm.id)}
                    className="mr-2"
                    autoComplete="off"
                  />
                  {itm.name}
                </label>
              );
            })}
          </>
        ) : (
          <input
            type={type}
            name={name}
            className={`relative  bg-white w-full rounded-lg h-11  overflow-hidden px-2 border border-[#E9EDF6] form-control ${className}`}
            required={required}
            placeholder={placeholder}
            value={
              (type == "datetime-local"
                ? datepipeModel.datetodatepicker(value)
                : value) || ""
            }
            maxLength={maxlength}
            minLength={minlength}
            min={min}
            disabled={disabled}
            autoComplete="off"
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onKeyDown={onkeyDown}
          />
        )}

        {error ? (
          <>
            <div className="text-danger small mt-1">{error}</div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
